import AuthService from '@/services/AuthService'
import UserService from '@/services/UserService'
import PurchasesService from '@/services/PurchasesService'

const authService = new AuthService()

const state = {
    authenticated: {},
    errors: {},
    user: {},
    subscriptions: [],
    status: 200,
}

const actions = {
    resetErrors({ commit }) {
        commit('RESET_ERRORS')
        commit('SET_STATUS', 200)
    },

    register({ commit, rootGetters }, user) {
        return new Promise((resolve, reject) => {
            authService
                .register(rootGetters['settings/get'], user, rootGetters['device/getDevice'])
                .then((response) => {
                    commit('AUTHENTICATE', response.data)
                    commit('SET_STATUS', 200)
                    commit('RESET_ERRORS')

                    resolve(response)
                })
                .catch((error) => {
                    const apiErrors = error.response.status === 422
                        ? error.response.data.errors
                        : error.response.data.message

                    commit('SET_STATUS', error.response.status)
                    commit('SET_ERRORS', apiErrors)

                    reject(error)
                })
        })
    },

    login({ commit, rootGetters }, user) {
        return new Promise((resolve, reject) => {
            authService
                .login(rootGetters['settings/get'], user, rootGetters['device/getDevice'])
                .then((response) => {
                    commit('AUTHENTICATE', response.data)
                    commit('SET_STATUS', 200)
                    commit('RESET_ERRORS')

                    resolve(response)
                })
                .catch((error) => {
                    const apiErrors = error.response.status === 422
                        ? error.response.data.errors
                        : error.response.data.message

                    commit('SET_STATUS', error.response.status)
                    commit('SET_ERRORS', apiErrors)

                    reject(error)
                })
        })
    },

    async get({ commit, rootGetters, dispatch }, access_token) {
        if (access_token === null) {
            throw new Error('No access token passed.')
        }

        const userService = new UserService(access_token)

        return userService.get(rootGetters['settings/get'])
            .then((response) => {
                commit('SET_USER', response.data.data)
            })
            .catch(() => {
                dispatch('logout')
            })
    },

    async subscriptions({ commit }, { key, userId }) {
        const purchasesService = new PurchasesService()

        await purchasesService
            .userStatus({ key, userId })
            .then((response) => commit('SET_SUBSCRIPTIONS', response.data))
    },

    async markUserOTPVerified({ commit }, { company_uuid, user_uuid, service_name, access_token }) {
        const userService = new UserService(access_token)

        return userService.otpVerify({ company_uuid, user_uuid })
            .then((response) => {
                if (response.data.state === 'Success') {
                    commit('SET_USER_VERIFIED', service_name)
                }
            })
    },

    restoreSession({ commit }, payload) {
        commit('AUTHENTICATE', payload);
    },

    logout({ commit }) {
        commit('CLEAR_AUTHENTICATE')
    },
}

const mutations = {
    AUTHENTICATE(state, payload) {
        state.authenticated = payload
    },
    SET_USER(state, user) {
        state.user = user
    },
    SET_SUBSCRIPTIONS(state, subscriptions) {
        state.subscriptions = subscriptions
    },
    SET_ERRORS(state, errors) {
        state.errors = errors
    },
    RESET_ERRORS(state) {
        state.errors = {}
    },
    SET_STATUS(state, status) {
        state.status = status
    },
    SET_USER_VERIFIED(state, serviceName) {
        if (typeof (state.user.third_party_services) === 'undefined') {
            state.user.third_party_services = []
        }

        const otpStatus = {
            service: serviceName,
            account: {
                otp: {
                    status: 'verified',
                    verified_at: new Date().toISOString(),
                },
            },
        }

        const entryIndex = state.user.third_party_services.map((entry) => entry.service).indexOf(serviceName)

        if (entryIndex !== -1) {
            state.user.third_party_services[entryIndex] = otpStatus
        } else {
            state.user.third_party_services.push(otpStatus)
        }
    },
    CLEAR_AUTHENTICATE(state) {
        state.authenticated = {}
    },
}

const getters = {
    validationErrors(state) {
        return (typeof state.errors === 'object' && Object.keys(state.errors).length) || state.errors.length
            ? state.errors
            : false
    },
    validationStatus(state) {
        return state.status
    },
    authenticated(state) {
        return state.authenticated
    },
    get(state) {
        return state.user
    },
    subscriptions(state) {
        return state.subscriptions
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
